import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import SubmissionsInbox from './personalRx/SubmissionsInbox';
import FlowGraphEditor from './personalRx/FlowGraphEditor';

export default function AdminPersonalRx() {
  const [tab, setTab] = useState<'inbox' | 'flow'>('inbox');
  const [unreadCount, setUnreadCount] = useState<number>(0);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      const { count } = await supabase
        .from('personal_rx_submissions')
        .select('*', { count: 'exact', head: true })
        .eq('status', 'new');
      if (mounted) setUnreadCount(count ?? 0);
    };
    load();
    // Poll every 30s instead of realtime (table is no longer in the realtime
    // publication to avoid leaking sensitive submissions over channels).
    const interval = setInterval(() => load(), 30_000);
    return () => {
      mounted = false;
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-semibold">רוקחות אישית</h1>
        <p className="text-sm text-muted-foreground">
          ניהול שאלון הרוקחות האישית ופניות שמתקבלות מהאתר. שינויים בעץ השאלות מתעדכנים מיידית באתר.
        </p>
      </div>

      <Tabs value={tab} onValueChange={(v) => setTab(v as typeof tab)}>
        <TabsList>
          <TabsTrigger value="inbox">
            פניות {unreadCount > 0 && (
              <span className="ms-2 inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-red-500 text-white text-[10px] font-bold">
                {unreadCount}
              </span>
            )}
          </TabsTrigger>
          <TabsTrigger value="flow">Flow</TabsTrigger>
        </TabsList>
        <TabsContent value="inbox" className="mt-5">
          <SubmissionsInbox />
        </TabsContent>
        <TabsContent value="flow" className="mt-5">
          <FlowGraphEditor />
        </TabsContent>
      </Tabs>
    </div>
  );
}
